import axios from "axios";
import { API_ROOT } from "../constants";
const ROOT_URL = API_ROOT;

export function getInstructorMembershipAnalytics(data) {
  return axios({
    method: "GET",
    params: data,
    url: `${ROOT_URL}/membership/analytics`,
  });
}

export function getClassInstructorList(id, data) {
  return axios({
    method: "GET",
    params: data,
    url: `${ROOT_URL}/class/${id}/list`,
  });
}
export function getInstructorNotifications(id, data) {
  return axios({
    method: "GET",
    params: data,
    url: `${ROOT_URL}/instructor/${id}/notifications`,
  });
}

export function getInstructorLeaderBoard(data) {
  return axios({
    method: "GET",
    params: data,
    url: `${ROOT_URL}/instructors/leaderboard`,
  });
}
